// extracted by mini-css-extract-plugin
export var askAiIcon = "_sb-9";
export var container = "_sb-0";
export var groupSeparator = "_sb-a";
export var highlight = "_sb-4";
export var resultIcon = "_sb-5";
export var resultItem = "_sb-7";
export var resultSubtitle = "_sb-3";
export var resultTitle = "_sb-2";
export var resultsList = "_sb-1";
export var searchGroup = "_sb-6";
export var selected = "_sb-8";